import { createExternalResourceSelectors } from '@next/arable-lib/external-resource';
import { createSelector } from '@ngrx/store';

import { OrganicMatterTable } from '../organic-matter-balance.models';
import { selectOrganicMatterBalanceState } from './organic-matter-balance.reducers';

export const OrganicMatterReportSelectors = createExternalResourceSelectors(
  selectOrganicMatterBalanceState, (state) => state.organicMatterReport,
);

export const OrganicMatterBenchmarkSelectors = createExternalResourceSelectors(
  selectOrganicMatterBalanceState, (state) => state.organicMatterBenchmark,
)

export const selectOrganicMatterTableReport = createSelector(OrganicMatterReportSelectors.selectData, (report) => {
  if (!report) {
    return [];
  }
  const tables: OrganicMatterTable[] = [];
  const allFieldsTable: OrganicMatterTable = {
    name: 'totalCropFields',
    translateName: true,
    totalHectares: report.totals?.hectares,
    balance: report.totals?.organicMatterBalance,
    balancePerHectare: report.totals?.organicMatterBalancePerHectare,
    organicMatterItems: [
      {
        source: 'cropSupply',
        data: {
          total: report.totals?.cropOrganicMatterSupply,
          perHectare: report.totals?.cropOrganicMatterSupplyPerHectare,
        },
      },
      {
        source: 'fertilizerSupply',
        data: {
          total: report.totals?.fertilizersOrganicMatterSupply,
          perHectare: report.totals?.fertilizersOrganicMatterSupplyPerHectare,
        },
      },
      {
        source: 'breakdown',
        data: {
          total: report.totals?.cropFieldOrganicMatterBreakdown,
          perHectare: report.totals?.cropFieldOrganicMatterBreakdownPerHectare,
        },
      },
    ],
    metaData: { isTotals: true },
  };
  tables.push(allFieldsTable);

  report.cropFields.forEach((cropFieldReport) => {
    const cropFieldTable: OrganicMatterTable = {
      name: `${cropFieldReport.name} (${cropFieldReport.cropName})`,
      translateName: false,
      totalHectares: cropFieldReport.hectares,
      balance: cropFieldReport.organicMatterBalance,
      balancePerHectare: cropFieldReport.organicMatterBalancePerHectare,
      organicMatterItems: [],
      metaData: { cropFieldName: cropFieldReport.name, cropName: cropFieldReport.cropName },
    };
    cropFieldTable.organicMatterItems.push({
      source: 'cropSupply',
      data: {
        total: cropFieldReport.cropOrganicMatterSupply,
        perHectare: cropFieldReport.cropOrganicMatterSupplyPerHectare,
      },
    });
    cropFieldTable.organicMatterItems.push({
      source: 'fertilizerSupply',
      data: {
        total: cropFieldReport.fertilizersOrganicMatterSupply,
        perHectare: cropFieldReport.fertilizersOrganicMatterSupplyPerHectare,
      },
    });
    cropFieldTable.organicMatterItems.push({
      source: 'breakdown',
      data: {
        total: cropFieldReport.cropFieldOrganicMatterBreakdown,
        perHectare: cropFieldReport.cropFieldOrganicMatterBreakdownPerHectare,
      },
    });
    tables.push(cropFieldTable);
  });
  const totals = tables.filter((item) => item.metaData.isTotals);
  const sorted = tables
    .filter((table) => !totals.includes(table))
    .sort(
      (a, b) =>
        (a.metaData.cropFieldName ?? '').localeCompare(b.metaData.cropFieldName ?? '') ||
        (a.metaData.cropName ?? '').localeCompare(b.metaData.cropName ?? ''),
    );
  return totals.concat(sorted);
});
